/*=========================================
	Global Events
=========================================*/

function setCookie(name, value) {
    document.cookie = `${name}=${value}`;
}
function handleChange(newValue) {
    setCookie('medical-certificate_lastQuestionafter', newValue);
}
function numberChange(lastNumber) {
    setCookie('medical-certificate_lastNumber', lastNumber);
}
function pushValueToCookieArray(key, newValue, afterQuestion, lastNumber) {
  var existingCookieValue = document.cookie.replace(new RegExp("(?:(?:^|.*;\\s*)" + key + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1");
  var existingObject = existingCookieValue ? JSON.parse(decodeURIComponent(existingCookieValue)) : {};

  existingObject.items = existingObject.items || [];
  existingObject.items.push(newValue);

  var expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 10); 

  var cookieString = key + "=" + encodeURIComponent(JSON.stringify(existingObject)) + "; expires=" + expirationDate.toUTCString() + "; path=/";
  document.cookie = cookieString;
  handleChange(afterQuestion);
  numberChange(lastNumber);
  
}
function getCookie(key) {
  var cookies = document.cookie.split(';');  
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf(key + '=') === 0) {
      return decodeURIComponent(cookie.substring(key.length + 1));
    }
  }
  return null;
}
function deleteCookie(key) {
  var expirationDate = new Date(0); // Set expiration date to a past date
  var cookieString = key + "=; expires=" + expirationDate.toUTCString() + "; path=/";

  document.cookie = cookieString;
}

$('.trigger-icon-button').on('click touch', function() {
    $(".country_dropdown").addClass("select_dropdown_show");
});

$(document).on('click touch', function(event) {
    if (!$(event.target).parents().addBack().is('.trigger-icon-button')) {
        $('.country_dropdown').removeClass('select_dropdown_show');
    }
});

$('.country_dropdown').on('click touch', function(event) {
    event.stopPropagation();
});

$.getJSON('https://cdn.shopify.com/s/files/1/0425/4197/3660/files/custom-countries.json?v=1784870873', function(data) {
    $(".country_list").empty();
    data.sort(function(a, b) {
        return a.name.localeCompare(b.name);
    });
    $.each(data, function(index, item) {
        var html = `
            <div class="country_select_option">
                <div class="country_select_bg">
                    <div class="country_select_wrapper">
                        <span><img src="${item.flag}" alt="${item.name}" style="max-width:28px;"><div class="country_text">${item.name}</div></span>
                        <div class="select_contentText"><div class="country_code">${item.code}</div></div>
                    </div>
                </div>
            </div>
        `;
        $(".country_list").append(html);
    });
    $('.country_select_option').on("click", function () {
        var image = $(this).find("img").attr("src");
        var code = $(this).find(".country_code").text();
        var country = $(this).find(".country_text").text();
        $(".distribute .trigger-icon-button__StrokeIcon img").attr("src", image);
        $(".country_dropdown").removeClass("select_dropdown_show");
        $(".select_country_box input").attr("data-contry-code", code);
        $("#checkNumber").attr("data-contry-code", code);
        $(".form-selected-answer [data-handle='country-code']").val(code);
        $(".selected-country-name").text(country);
    });
});

$("#search_countries").on("keyup", function() {
    var value = $(this).val().toLowerCase();
    $(".country_list .country_select_option").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
});

function shakeEffect($selector) {
    $selector.removeClass('shake_animation');
    setTimeout(function() {
        $selector.addClass('shake_animation');
        setTimeout(function() {
            $selector.removeClass('shake_animation');
        }, 600);
    }, 10);
}

$('.dm-data-validate').keypress(function(e) {
    if (e.which == 13) {
        $(this).parents('.form_loop').find('button').click();
    }
    var $limit = parseInt($(this).attr('maxlength'));
    if ($(this).val().length <= $limit) {} else {
        shakeEffect($(this).parents('.form_loop'));
        return false;
    }
});

$('.form_loop textarea').keypress(function(e) {
    if (e.which == 13 && !e.shiftKey) {
        $(this).parents('.form_loop').find('button').click();
        return false;
    }
});

$('.dm-data-validate').keyup(function() {
    var d = new Date();
    var $max = parseInt($(this).attr('max')) || d.getFullYear();

    if ($(this).val() > $max) {
        shakeEffect($(this).parents('.form_loop'));
        return false;
    }
});

var queDataAttr = [];
$('.dm-question').each(function(i) {
    var $question = $(this).html();
    var $que = $question;
    $que = $que.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    $(this).parents('.form_loop').attr('data-question', $que);
    var $hidden = '<input type="hidden" name="' + $question + '" data-handle="' + $que + '">';
    $('.form-selected-answer').append($hidden);
    queDataAttr[i] = `${$que}`;
});
$('.form-selected-answer').append('<input type="hidden" name="country code" data-handle="country-code" value="+61">');
$('.form-selected-answer [data-handle="please-enter-your-medicare-card-details"]').remove();
$('.form-selected-answer [data-handle="what-is-your-ihi"]').remove();

$('.unfortunately_country_title .back_btn_content button,.unfortunately_title .back_btn_content button, .book-consiltation-doctor .back_btn_content button, .book_consultation .back_btn_content button').click(function() {
    var Goto = $(this).attr('goto');
    var $indexGoto = $('.form_loop[data-question=' + Goto + ']').index();
    $('.form_loop').removeClass('d-none').removeClass('d-block');

    var $limit = $('.form_loop').length;
    for (i = 0; i < $limit; i++) {
        if (i == $indexGoto) {
            $('.form_loop[data-question=' + Goto + ']').addClass('d-block').animate({
                scrollTop: 0
            });
            break;
        } else {
            var j = i + 1;
            $('.form_loop:nth-child(' + j + ')').addClass('d-none');
        }
    }
});

$('.form_loop input[type=checkbox]').click(function() {
    var Name = $(this).attr('name');
    var $parent = $(this).parents('.form_loop');
    $parent.find('input[name=' + Name + ']:checked').not(this).prop('checked', false);
});

var que0 = "why-are-you-unable-to-attend-work";
var que1 = "what-is-the-relationship-to-the-person-you-are-caring-for-e-g-parent-caregiver-or-spouse";
var que2 = "what-is-the-first-day-you-are-unable-to-attend";
var que3 = "how-many-days-do-you-require";
var que4 = "please-have-the-person-you-are-caring-for-answer-the-following-questions-or-you-may-answer-on-their-behalf";
var que5 = "what-symptoms-have-you-been-experiencing";
var que6 = "how-long-have-you-been-sick-for";
var que7 = "is-there-any-chest-pain-shortness-of-breath-sever-headache-fever-higher-than-39-stiff-neck-loss-of-consciousness-severe-abdominal-pain-uncontrolled-vomiting-visual-disturbance-one-sided-body-muscle-weakness-loss-of-control-over-your-bladder-or-bowels-incontinent";
var que8 = "please-explain-as-much-as-possible-about-your-symptoms";
var que9 = "do-you-need-any-medications-do-you-need-to-speak-to-a-doctor";
var que10 = "will-you-see-your-doctor-within-the-next-day-if-your-symptoms-not-improving";
var que11 = "do-you-acknowledge-that-the-certificate-will-be-given-for-up-to-two-days-only-you-can-order-a-maximum-of-5-certificate-in-a-6-months-period-if-you-require-multiple-days-you-need-to-speak-to-your-regular-gp";
var que12 = "would-you-agree-to-go-to-emergency-department-or-call-000-if-your-medical-condition-gets-worse";
var que13 = "will-you-acknowledge-that-our-service-is-very-limited-and-we-as-doctors-rely-on-your-statement-and-can-not-guarantee-any-misdiagnosis-as-we-are-not-able-to-directly-examine-you";
var que14 = "do-you-understand-everything-that-is-written-above-or-do-you-require-assistance-or-language-interpretation";
var que15 = "how-long-have-you-been-suffering-from-your-condition";
var que16 = "are-you-taking-any-medications-for-any-reasons";
var que17 = "please-list-which-medications-you-take";
var que18 = "have-you-ever-been-treated-for-mental-illness-in-the-past";
var que19 = "please-explain-what-mental-illness-you-have-been-treated-for-in-the-past";
var que20 = "have-you-had-any-prior-mental-illness-diagnosis";
var que21 = "please-provide-details-on-your-previous-mental-illness-diagnosis";
var que22 = "has-your-sleep-been-disturbed";
var que23 = "have-you-been-feeling-suicidal-or-self-harm";
var que24 = "have-you-ever-tried-to-self-harm-or-attempt-a-suicide";
var que25 = "is-there-any-family-history-of-suicide-in-your-family";
var que26 = "do-you-hear-any-voices-or-see-things-that-are-not-real-such-as-hallucinations";
var que27 = "do-you-use-any-recreational-drugs";
// var que28 = "do-you-need-to-take-any-medication";
var que29 = "what-medication-do-you-take";
// var que30 = "do-you-need-to-speak-to-a-doctor";
var que31 = "will-you-agree-to-see-your-regular-gp-within-next-day-if-no-improvement-in-your-symptoms";
var que32 = "would-you-agree-to-call-000-or-life-line-number-on-13-11-14-if-feeling-suicidal-or-self-harm";
// var que33 = "will-you-acknowledge-that-our-service-is-very-limited-and-we-as-doctors-rely-on-your-statement-and-cannot-guarantee-any-misdiagnosis-as-we-are-not-able-to-directly-examine-you";
var que34 = "would-you-acknowledge-that-your-symptoms-are-mild-and-do-not-need-urgent-medical-or-psychiatric-attention";
var que35 = "please-enter-your-gender";
var que36 = "discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-medical-certificate-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id";
var que37 = "based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-a-personalised-medical-certificate-please-complete-your-mobile-phone-number-to-purchase-your-medical-certificate-for-29-95";
var que38 = "please-enter-your-date-of-birth";
var que39 = "which-country-do-you-live-in";
var que40 = "do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication";

// new Question 7 aug =====
var que41 = "would-you-like-to-skip-the-questionnaire-and-speak-with-a-doctor-or-nurse-practitioner-instead";
var que42 = "do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues";
var que43 = "please-list-any-regular-medications-you-take-any-known-allergies-or-any-medical-issues";


/*=========================================
    End Of Global Events
=========================================*/

//   FIRST YES BTN
$('.first_questions_section .form_action_btn').click(function() {
    $(this).parents('.form_loop').removeClass('d-block').addClass('d-none').next().addClass('d-block');
    $('.progress_content').show();
    pushHistory(1);
    $('html, body').animate({
      scrollTop: 0
    }, 800);
    var cookieToDelete = 'medical-certificate';
    deleteCookie(cookieToDelete);
    deleteCookie("medical-certificate_lastQuestionafter");
  $('.form-selected-answer input[type="hidden"]').each(function(){
    $(this).val("");
  })
});

$('.continue_btn_content .continue_action_btn').click(function() {
  var weightLossCookieValue = getCookie('medical-certificate_lastQuestionafter');
  var weightLosslatnumCookieValue = getCookie('medical-certificate_lastNumber');
  
  if (weightLossCookieValue !== null) {

    $(this).parents('.form_loop').removeClass('d-block').addClass('d-none');
    
    $('.questionnaire_form_main .form_loop').each(function(){
      var selfQuestions = $(this).data('question');
      if(selfQuestions == weightLossCookieValue){
          $(this).addClass('d-block').find('.number').html(weightLosslatnumCookieValue);
      }
    });
  }
});

$('.form-selected-answer input[type="hidden"]').each(function(){
  var selfHandle = $(this).attr('data-handle');
  var weightLossCookieValue = getCookie('medical-certificate');
  if (weightLossCookieValue !== null) {
      $('.continue_btn_content').removeClass('hidden');
      var weightLossObject = JSON.parse(weightLossCookieValue);
      var weightLossObjectItem = weightLossObject.items;
      for (var i = 0; i < weightLossObjectItem.length; i++) {
      var currentObject = weightLossObjectItem[i];
      for (var key in currentObject) {
        if (currentObject.hasOwnProperty(key)) {
          var cookieValue = currentObject[key];
          if(key == selfHandle){
            $('.form-selected-answer [data-handle=' + key + ']').val(cookieValue);
          }else{
            if($('#callback-form input[data-handle="'+key+'"]').length == 0){
              var getName = $(".form_loop[data-question='"+ key +"' ] .dm-question").text();
              var getQuestion = getName;
              $('.form-selected-answer').append('<input type="hidden" name="'+getQuestion+'" data-handle="'+key+'">');
              $('.form-selected-answer [data-handle=' + key + ']').val(cookieValue);
            }
          }
        }
      }
    }
    
    if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'no' || $('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'No'){
        if($('#callback-form input[data-handle="what-is-your-ihi"]').length == 0){ 
          $('.form-selected-answer').append('<input type="hidden" name="What is your IHI?" data-handle="what-is-your-ihi">');
        }
     }else if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'yes' || $('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'Yes'){
       if($('#callback-form input[data-handle="please-enter-your-medicare-card-details"]').length == 0){ 
          $('.form-selected-answer').append('<input type="hidden" name="Please enter your Medicare Card details" data-handle="please-enter-your-medicare-card-details">');
          var irnHtml = '<input type="hidden" name="irn_number" data-handle="do-you-have-a-medicare-card_irn">',
              cardNumberHtml = '<input type="hidden" name="medicare-card_number" data-handle="do-you-have-a-medicare-card_number">',
              monthYearHtml = '<input type="hidden" name="medicare-card_month_year" data-handle="do-you-have-a-medicare-card_month_year">';
          $('.form-selected-answer').append([irnHtml, cardNumberHtml, monthYearHtml]);
       }
     }

     if($('.form-selected-answer [data-handle="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"]').val() == 'Yes' || $('.form-selected-answer [data-handle="do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication"]').val() == 'yes'){
          if($('#callback-form input[data-handle="do-you-have-an-nhi"]').length == 0){ 
            $('.form-selected-answer').append('<input type="hidden" name="Do you have an NHI?" data-handle="do-you-have-an-nhi">');
          }
      }

      if($('.form-selected-answer [data-handle="do-you-have-an-nhi"]').val() == 'Yes' || $('.form-selected-answer [data-handle="do-you-have-an-nhi"]').val() == 'yes'){
          if($('#callback-form input[data-handle="what-is-your-nhi"]').length == 0){ 
            $('.form-selected-answer').append('<input type="hidden" name="What is your NHI?" data-handle="what-is-your-nhi">');
          }
      }
    
  }
});

//  Scountry selector
$('.form_loop[data-question=' + que39 + '] .form_action_btn, .form_loop[data-question=' + que39 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this),
        $currentNumber = parseInt($('.form_loop[data-question=' + que0 + ']').find('.number').html());

      
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $value = $parent.find('input[type=checkbox]:checked').val();

              if($value == "NZ") {
                $parent.removeClass('d-block').addClass('d-none');
                $('.unfortunately_country_title').addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
              }else{
                $('.maintaining_option input[value=mounjaro]').parent('li').removeClass('hide');
                $('.maintaining_option input[value=ozempic]').parent('li').removeClass('hide');

                var newValue = { 'which-country-do-you-live-in': $value };
                var afterlastQuestion = $parent.next().data("question");
                pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber); 
          
                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block');
                $('.form-selected-answer [data-handle=' + que39 + ']').val($value);
              }
                
                CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 100);
});

// $('.form_loop[data-question=' + que41 + '] input[type=checkbox]').click(function() {
//     ValidateRemove();
//     var $this = $(this),
//         Name = $this.attr('name'),
//         $parent = $this.parents('.form_loop'),
//         $currentNumber = parseInt($parent.find('.number').html());
//       setTimeout(function() {
//         if ($parent.find('input[name=' + Name + ']:checked').length) {
//             $('.form-selected-answer [data-handle=' + que41 + ']').val($this.val());
//           if ($this.val() == 'Yes') {
//             // $(".ihi_question .form_submit_btn").addClass("hide_btn");
//             // $(".ihi_question .form_next_btn").removeClass("hide_btn");
//             var newValue = { 'would-you-like-to-skip-the-questionnaire-and-speak-with-a-doctor-or-nurse-practitioner-instead': $this.val()};
//             $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
//             $('.form_loop[data-question="discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-medical-certificate-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id"]').addClass('d-block').find('.number').html($currentNumber + 1);
//             var afterlastQuestion = $('.form_loop[data-question="discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-medical-certificate-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id"]').data("question");
//             pushHistory($currentNumber + 1);
//             CalculateP();
//           }else {
//             // $(".ihi_question .form_submit_btn").removeClass("hide_btn");
//             // $(".ihi_question .form_next_btn").addClass("hide_btn");
//             $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
//             $('.form_loop[data-question="why-are-you-unable-to-attend-work"]').addClass('d-block').find('.number').html($currentNumber + 1);
//             pushHistory($currentNumber + 1);
//             CalculateP();
//             var afterlastQuestion = $('.form_loop[data-question="why-are-you-unable-to-attend-work"]').data("question");
//           }
          
//             pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);
//         }
//       }, 100);
// });

$('.form_loop[data-question=' + que42 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que42 + ']').val($this.val());
           var newValue = { 'do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues': $this.val()};
          if ($this.val() == 'Yes') {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          }else {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
            $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-a-personalised-medical-certificate-please-complete-your-mobile-phone-number-to-purchase-your-medical-certificate-for-29-95"]').addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-a-personalised-medical-certificate-please-complete-your-mobile-phone-number-to-purchase-your-medical-certificate-for-29-95"]').data("question");
          }
          
            pushHistory($currentNumber + 1);
            CalculateP();
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);
        }
      }, 100);
});


$('.form_loop[data-question=' + que43 + '] button').click(function() {
      ValidateRemove();  
      var $this = $(this),
          Name = $this.attr('name'),
          $parent = $this.parents('.form_loop'),
          $currentNumber = parseInt($parent.find('.number').html()),
          $value = $parent.find('textarea').val(),
          $value = $value.trim();
      if ($value.length) {
          $('.form-selected-answer [data-handle=' + que43 + ']').val($value);
          var newValue = { 'please-list-any-regular-medications-you-take-any-known-allergies-or-any-medical-issues': $value };
          $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
          $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-a-personalised-medical-certificate-please-complete-your-mobile-phone-number-to-purchase-your-medical-certificate-for-29-95"]').addClass('d-block').find('.number').html($currentNumber + 1);
          var afterlastQuestion = $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-a-personalised-medical-certificate-please-complete-your-mobile-phone-number-to-purchase-your-medical-certificate-for-29-95"]').data("question");
        
          pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);  
          pushHistory($currentNumber + 1);
          CalculateP();
      } else {
          shakeEffect($parent);
          $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
          setTimeout(function() {
              $('.valid_date_text').remove();
          }, 2500);
      }
  });


//  STEP 1
$('.form_loop[data-question=' + que0 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
  console.log($currentNumber,'$currentNumber')
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            var newValue = { 'why-are-you-unable-to-attend-work': $this.val() };
            if ($this.val() == 'someone-i-care-for-is-unwell-and-i-would-be-unable-to-attend-while-i-care-for-them') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $this.parents('.form_loop').next().next().data("question");
            }
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
            $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que0}">`);
            $('.form-selected-answer [data-handle=' + que0 + ']').val($this.val());
            console.log($currentNumber, '$currentNumber')
            pushHistory($currentNumber + 1);
            CalculateP();
        }
    }, 100);
});

// STEP 2
$('.form_loop[data-question=' + que1 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que1}">`);
        $('.form-selected-answer [data-handle=' + que1 + ']').val($value);
        var newValue = { 'what-is-the-relationship-to-the-person-you-are-caring-for-e-g-parent-caregiver-or-spouse': $value };
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 3
$('.form_loop[data-question=' + que2 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            var newValue = { 'what-is-the-first-day-you-are-unable-to-attend': $this.val() };
            $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que2}">`);
            $('.form-selected-answer [data-handle=' + que2 + ']').val($this.val());
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
        }
    }, 100);
});


// STEP 4
$('.form_loop[data-question=' + que3 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            var newValue = { 'how-many-days-do-you-require': $this.val() };
            if ($('.form-selected-answer [data-handle=' + que0 + ']').val() == 'someone-i-care-for-is-unwell-and-i-would-be-unable-to-attend-while-i-care-for-them') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $this.parents('.form_loop').next().next().data("question");
            }
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
            $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que3}">`);
            $('.form-selected-answer [data-handle=' + que3 + ']').val($this.val());
            pushHistory($currentNumber + 1);
            CalculateP();
        }
    }, 100);
});

// STEP 5
$('.form_loop[data-question=' + que4 + '] .form_action_btn').click(function() {
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que4}">`);
        $('.form-selected-answer [data-handle=' + que4 + ']').val(1);
        $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
        pushHistory($currentNumber + 1);
        CalculateP();
        var newValue = { 'please-have-the-person-you-are-caring-for-answer-the-following-questions-or-you-may-answer-on-their-behalf': 1 };
        var afterlastQuestion = $this.parents('.form_loop').next().data("question");
        pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
    }, 100);
});

// STEP 6
$('.form_loop[data-question=' + que5 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que5}">`);
            $('.form-selected-answer [data-handle=' + que5 + ']').val($this.val());
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'what-symptoms-have-you-been-experiencing': $this.val() };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
        }
    }, 100);
});


// STEP 7
$('.form_loop[data-question=' + que6 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que6}">`);
        $('.form-selected-answer [data-handle=' + que6 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'how-long-have-you-been-sick-for': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 8
$('.form_loop[data-question=' + que7 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            var newValue = { 'is-there-any-chest-pain-shortness-of-breath-sever-headache-fever-higher-than-39-stiff-neck-loss-of-consciousness-severe-abdominal-pain-uncontrolled-vomiting-visual-disturbance-one-sided-body-muscle-weakness-loss-of-control-over-your-bladder-or-bowels-incontinent': $this.val() };
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                  $('.book_consultation_only_nz').addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                  var afterlastQuestion = $('.book_consultation_only_nz').data("question");
                }else {
                  $('.book_consultation').not($('.book_consultation_only_nz')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                  var afterlastQuestion = $('.book_consultation').not($('.book_consultation_only_nz')).data("question");
                }
            } else {
                $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que7}">`);
                $('.form-selected-answer [data-handle=' + que7 + ']').val($this.val());
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            }
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
        }
    }, 100);
});

// STEP 9
$('.form_loop[data-question=' + que8 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que8}">`);
        $('.form-selected-answer [data-handle=' + que8 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'please-explain-as-much-as-possible-about-your-symptoms': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 10
$('.form_loop[data-question=' + que9 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            var newValue = { 'do-you-need-any-medications-do-you-need-to-speak-to-a-doctor': $this.val() };
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                  $('.book_consultation_only_nz').addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                  var afterlastQuestion = $('.book_consultation_only_nz').data("question");
                }else {
                  $('.book_consultation').not($('.book_consultation_only_nz')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                  var afterlastQuestion =  $('.book_consultation').not($('.book_consultation_only_nz')).data("question");
                }
            } else {
                $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que9}">`);
                $('.form-selected-answer [data-handle=' + que9 + ']').val($this.val());
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion =  $this.parents('.form_loop').next().data("question");
            }
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
        }
    }, 100);
});

// STEP 11
$('.form_loop[data-question=' + que10 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            var newValue = { 'will-you-see-your-doctor-within-the-next-day-if-your-symptoms-not-improving': $this.val() };
            if ($this.val() == 'Yes') {
                $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que10}">`);
                $('.form-selected-answer [data-handle=' + que10 + ']').val($this.val());
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
              if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                $('.unfortunately_title_only_back').not(".unfortunately_country_title").addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
              }else {
                $('.unfortunately_title').not($('.unfortunately_title_only_back,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
              }
            }
        }
    }, 100);
});

// STEP 12
$('.form_loop[data-question=' + que11 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            var newValue = { 'do-you-acknowledge-that-the-certificate-will-be-given-for-up-to-two-days-only-you-can-order-a-maximum-of-5-certificate-in-a-6-months-period-if-you-require-multiple-days-you-need-to-speak-to-your-regular-gp': $this.val() };
            if ($this.val() == 'Yes') {
                $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que11}">`);
                $('.form-selected-answer [data-handle=' + que11 + ']').val($this.val());
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                  $('.unfortunately_title_only_back').not(".unfortunately_country_title").addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }else {
                  $('.unfortunately_title').not($('.unfortunately_title_only_back,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }
            }
        }
    }, 100);
});

// STEP 13
$('.form_loop[data-question=' + que12 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            var newValue = { 'would-you-agree-to-go-to-emergency-department-or-call-000-if-your-medical-condition-gets-worse': $this.val() };
            if ($this.val() == 'Yes') {
                if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                   var que12 = "would-you-agree-to-go-to-emergency-department-or-call-111-if-your-medical-condition-gets-worse";   // dm- chnage 09 oct ===========
                }
                $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que12}">`);
                $('.form-selected-answer [data-handle=' + que12 + ']').val($this.val());
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                  $('.unfortunately_title_only_back').not(".unfortunately_country_title").addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }else {
                  $('.unfortunately_title').not($('.unfortunately_title_only_back,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }
            }
        }
    }, 100);
});

// STEP 14
$('.form_loop[data-question=' + que13 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            if ($this.val() == 'Yes') {
                $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que13}">`);
                $('.form-selected-answer [data-handle=' + que13 + ']').val($this.val());
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var newValue = { 'will-you-acknowledge-that-our-service-is-very-limited-and-we-as-doctors-rely-on-your-statement-and-can-not-guarantee-any-misdiagnosis-as-we-are-not-able-to-directly-examine-you': $this.val() };
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                  $('.unfortunately_title_only_back').not(".unfortunately_country_title").addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }else {
                  $('.unfortunately_title').not($('.unfortunately_title_only_back,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }
            }
        }
    }, 100);
});

// STEP 15
$('.form_loop[data-question=' + que14 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            if ($this.val() == 'Yes') {
                var newValue = { 'do-you-understand-everything-that-is-written-above-or-do-you-require-assistance-or-language-interpretation': $this.val() };
                if ($('.form-selected-answer [data-handle=' + que5 + ']').val() == 'Stress' || $('.form-selected-answer [data-handle=' + que5 + ']').val() == 'Mental health related') {
                    $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                    var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                } else {
                    $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                    $('.form_loop[data-question=' + que34 + ']').addClass('d-block').removeClass('d-none').find('.number').html($currentNumber + 1);
                    var afterlastQuestion =  $('.form_loop[data-question=' + que34 + ']').data("question");
                }
                $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que14}">`);
                $('.form-selected-answer [data-handle=' + que14 + ']').val($this.val());
                pushHistory($currentNumber + 1);
                CalculateP();
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                  $('.book_consultation_only_nz').addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                  var afterlastQuestion =  $('.book_consultation_only_nz').data("question");
                }else {
                  $('.book_consultation').not($('.book_consultation_only_nz')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                  var afterlastQuestion =  $('.book_consultation').not($('.book_consultation_only_nz')).data("question");
                }
            }
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
        }
    }, 100);
});

// STEP 16
$('.form_loop[data-question=' + que15 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que15}">`);
        $('.form-selected-answer [data-handle=' + que15 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'how-long-have-you-been-suffering-from-your-conditionf': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 17
$('.form_loop[data-question=' + que16 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que16}">`);
            $('.form-selected-answer [data-handle=' + que16 + ']').val($this.val());
            var newValue = { 'are-you-taking-any-medications-for-any-reasons': $this.val() };
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $this.parents('.form_loop').next().next().data("question");
            }
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
            pushHistory($currentNumber + 1);
            CalculateP();
        }
    }, 100);
});

// STEP 18
$('.form_loop[data-question=' + que17 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que17}">`);
        $('.form-selected-answer [data-handle=' + que17 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'please-list-which-medications-you-take': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 19
$('.form_loop[data-question=' + que18 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que18}">`);
            $('.form-selected-answer [data-handle=' + que18 + ']').val($this.val());
            var newValue = { 'have-you-ever-been-treated-for-mental-illness-in-the-past': $this.val() };
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $this.parents('.form_loop').next().next().data("question");
            }
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
            pushHistory($currentNumber + 1);
            CalculateP();
        }
    }, 100);
});

// STEP 20
$('.form_loop[data-question=' + que19 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que19}">`);
        $('.form-selected-answer [data-handle=' + que19 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'please-explain-what-mental-illness-you-have-been-treated-for-in-the-past': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 21
$('.form_loop[data-question=' + que20 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que20}">`);
            $('.form-selected-answer [data-handle=' + que20 + ']').val($this.val());
            var newValue = { 'have-you-had-any-prior-mental-illness-diagnosis': $this.val() };
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $this.parents('.form_loop').next().next().data("question");
            }
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
            pushHistory($currentNumber + 1);
            CalculateP();
        }
    }, 100);
});

// STEP 22
$('.form_loop[data-question=' + que21 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que21}">`);
        $('.form-selected-answer [data-handle=' + que21 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'please-provide-details-on-your-previous-mental-illness-diagnosis': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 23
$('.form_loop[data-question=' + que22 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que22}">`);
            $('.form-selected-answer [data-handle=' + que22 + ']').val($this.val());
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'has-your-sleep-been-disturbed': $this.val() };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);
        }
    }, 100);
});

// STEP 24
$('.form_loop[data-question=' + que23 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            var newValue = { 'have-you-been-feeling-suicidal-or-self-harm': $this.val() };
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                  $('.unfortunately_title_only_back').not(".unfortunately_country_title").addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }else {
                  $('.unfortunately_title').not($('.unfortunately_title_only_back,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }
            } else {
                $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que23}">`);
                $('.form-selected-answer [data-handle=' + que23 + ']').val($this.val());
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1); 
            }
        }
    }, 100);
});

// STEP 25
$('.form_loop[data-question=' + que24 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                  $('.unfortunately_title_only_back').not(".unfortunately_country_title").addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }else {
                  $('.unfortunately_title').not($('.unfortunately_title_only_back,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }
            } else {
                $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que24}">`);
                $('.form-selected-answer [data-handle=' + que24 + ']').val($this.val());
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var newValue = { 'have-you-ever-tried-to-self-harm-or-attempt-a-suicide': $this.val() };
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);
            }
        }
    }, 100);
});

// STEP 26
$('.form_loop[data-question=' + que25 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que25}">`);
            $('.form-selected-answer [data-handle=' + que25 + ']').val($this.val());
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'is-there-any-family-history-of-suicide-in-your-family': $this.val() };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);
        }
    }, 100);
});

// STEP 27
$('.form_loop[data-question=' + que26 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                  $('.unfortunately_title_only_back').not(".unfortunately_country_title").addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }else {
                  $('.unfortunately_title').not($('.unfortunately_title_only_back,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }
            } else {
                $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que26}">`);
                $('.form-selected-answer [data-handle=' + que26 + ']').val($this.val());
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var newValue = { 'do-you-hear-any-voices-or-see-things-that-are-not-real-such-as-hallucinations': $this.val() };
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);
            }
        }
    }, 100);
});

// STEP 28
$('.form_loop[data-question=' + que27 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                  $('.unfortunately_title_only_back').not(".unfortunately_country_title").addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }else {
                  $('.unfortunately_title').not($('.unfortunately_title_only_back,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }
            } else {
                $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que27}">`);
                $('.form-selected-answer [data-handle=' + que27 + ']').val($this.val());
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var newValue = { 'do-you-use-any-recreational-drugs': $this.val() };
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);
            }
        }
    }, 100);
});

// STEP 29
// $('.form_loop[data-question=' + que28 + '] input[type=checkbox]').click(function() {
//     ValidateRemove();
//     var $this = $(this),
//         Name = $this.attr('name'),
//         $parent = $this.parents('.form_loop'),
//         $selector = $parent.find('.dm-question').html(),
//         $currentNumber = parseInt($parent.find('.number').html());
//     setTimeout(function() {
//         if ($parent.find('input[name=' + Name + ']:checked').length) {
//             $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que28}">`);
//             $('.form-selected-answer [data-handle=' + que28 + ']').val($this.val());
//             if ($this.val() == 'Yes') {
//                 $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
//             } else {
//                 $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
//             }
//             pushHistory($currentNumber + 1);
//             CalculateP();
//         }
//     }, 100);
// });

// STEP 30
$('.form_loop[data-question=' + que29 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que29}">`);
        $('.form-selected-answer [data-handle=' + que29 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'what-medication-do-you-take': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 32
$('.form_loop[data-question=' + que31 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            if ($this.val() == 'Yes') {
                $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que31}">`);
                $('.form-selected-answer [data-handle=' + que31 + ']').val($this.val());
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var newValue = { 'will-you-agree-to-see-your-regular-gp-within-next-day-if-no-improvement-in-your-symptoms': $this.val() };
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                 if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                  $('.unfortunately_title_only_back').not(".unfortunately_country_title").addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }else {
                  $('.unfortunately_title').not($('.unfortunately_title_only_back,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }
            }
        }
    }, 100);
});

// STEP 33
$('.form_loop[data-question=' + que32 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            if ($this.val() == 'Yes') {
                if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                   var que32 = "would-you-agree-to-call-111-or-life-line-number-on-0800-543-354-if-feeling-suicidal-or-self-harm";    // dm- chnage 09 oct ===========
                }
                $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que32}">`);
                $('.form-selected-answer [data-handle=' + que32 + ']').val($this.val());
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var newValue = { 'would-you-agree-to-call-000-or-life-line-number-on-13-11-14-if-feeling-suicidal-or-self-harm': $this.val() };
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                  $('.unfortunately_title_only_back').not(".unfortunately_country_title").addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }else {
                  $('.unfortunately_title').not($('.unfortunately_title_only_back,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question')); 
                }
            }
        }
    }, 100);
});

// STEP 36
$('.form_loop[data-question=' + que34 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            if ($this.val() == 'Yes') {
                $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que34}">`);
                $('.form-selected-answer [data-handle=' + que34 + ']').val($this.val());
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var newValue = { 'would-you-acknowledge-that-your-symptoms-are-mild-and-do-not-need-urgent-medical-or-psychiatric-attention': $this.val() };
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
               if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                $('.unfortunately_title_only_back').not(".unfortunately_country_title").addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
              }else {
                $('.unfortunately_title').not($('.unfortunately_title_only_back,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
              }
            }
        }
    }, 100);
});

// STEP 37
$('.form_loop[data-question=' + que35 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que35}">`);
            $('.form-selected-answer [data-handle=' + que35 + ']').val($this.val());
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'please-enter-your-gender': $this.val() };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);
        }
    }, 100);
});

// STEP 38
$('.form_loop[data-question=' + que36 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();

    if ($value.length) {
        $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que36}">`);
        $('.form-selected-answer [data-handle=' + que36 + ']').val($value);
      
        setTimeout(function() {
            if ($('.form-selected-answer [data-handle=' + que41 + ']').val() == 'Yes') {
              $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
              $('.form_loop[data-question="please-enter-your-date-of-birth"]').addClass('d-block').find('.number').html($currentNumber + 1);
              var afterlastQuestion = $('.form_loop[data-question="please-enter-your-date-of-birth"]').data("question");
            }else { 
              $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
              var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            }
          
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-medical-certificate-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id': $value };
            pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);
        }, 100);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});



// STEP 40
$('.form_loop[data-question=' + que40 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            if ($this.val() == 'Yes') {
                $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que40}">`);
                $('.form-selected-answer [data-handle=' + que40 + ']').val($this.val());
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var newValue = { 'do-you-agree-to-use-burst-health-s-preferred-pharmacy-provider-to-ensure-the-fastest-delivery-time-of-your-prescribed-medication': $this.val() };
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
               if($('.form-selected-answer [data-handle=' + que39 + ']').val() == 'NZ'){
                $('.unfortunately_title_only_back').not(".unfortunately_country_title").addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
              }else {
                $('.unfortunately_title').not($('.unfortunately_title_only_back,.unfortunately_country_title')).addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
              }
            }
        }
    }, 100);
});



$('.form_loop[data-question=' + que38 + '] .form_action_btn').click(function() {
    ValidateRemove();
    $('.dm-error').remove();
    var $MM = $('.birth_date_field .month input').val(),
        $DD = $('.birth_date_field .day input').val(),
        $YY = $('.birth_date_field .year input').val();
    var InputDate = new Date($MM + '/' + $DD + '/' + $YY);
    var $parent = $(this).parents('.form_loop');
    var $selector = $parent.find('.dm-question').html();
    var Today = new Date();
    var $currentNumber = parseInt($(this).parents('.form_loop').find('.number').html());

    var Difference_In_Time = Today.getTime() - InputDate.getTime();

    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24 * 365);

    $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que38}">`);
    if (Difference_In_Days >= 18 && ($MM.length <= 2 && $DD.length <= 2 && $YY.length == 4)) {
        pushHistory($currentNumber + 1);

        $(this).parents('.form_loop').removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
        var afterlastQuestion = $(this).parents('.form_loop').next().data("question");
        $('.form-selected-answer [data-handle=' + que38 + ']').val($DD + '/' + $MM + '/' + $YY);
        CalculateP();
        var newValue = { 'please-enter-your-date-of-birth': $DD + '/' + $MM + '/' + $YY };
        pushValueToCookieArray('medical-certificate', newValue, afterlastQuestion, $currentNumber + 1);
    } else {
        shakeEffect($(this).parents('.form_loop'));
        $($('#error-template').html()).insertAfter($(this).parents('.form_loop').find('.birth_date_field'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// STEP 41
$('.form_loop[data-question=' + que37 + '] .form_submit_btn button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $selector = $parent.find('.dm-question').html(),
        $currentNumber = parseInt($parent.find('.number').html());

    var mobile_number_length = 10;
    var get_country_type = $('.form-selected-answer [data-handle=' + que39 + ']').val(); 
    if(get_country_type == 'NZ'){
      mobile_number_length = 9;
    }
  
    console.log($parent.find('.select_country_box input').val().length >= mobile_number_length,"$parent.find('.select_country_box input').val().length >= mobile_number_length",$parent.find('.select_country_box input').val().length , mobile_number_length)
    if ($parent.find('.select_country_box input').val().length >= mobile_number_length) {
        $this.attr('disabled', 'disabled');
        var Value = $parent.find('.select_country_box input').val(),
            Ccode = $parent.find('.select_country_box input').data('contry-code');

        $('.form-selected-answer [data-handle=country-code]').val(Ccode);
        $('.form-selected-answer').append(`<input type="hidden" name="${$selector}" data-handle="${que37}">`);
        $('#checkNumber').val(Value);

      if(get_country_type == 'NZ'){
        $('.form-selected-answer [data-handle=' + que37 + ']').val(Value);
        $('.form_loop[data-question=' + que37 + '] button').find('input').val(Value);
        $('.form_loop[data-question=' + que37 + '] button').parents('.form_loop').addClass('d-none').removeClass('d-block');
        $('#callback-form').submit();
      }else {
        $('#confirmation_popup').toggle();
      }
      
        CalculateP();
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

function otpAfterClick() {
$('#confirmation_popup .confirm_button').click(function(){
   var checkVal = $(this).parents('#confirmation_popup').find('#checkNumber').val();
   if (checkVal.length > 9) {
    $('#confirmation_popup').toggle();
    $('.form-selected-answer [data-handle=' + que37 + ']').val(checkVal);
    $('.form_loop[data-question=' + que37 + '] button').find('input').val(checkVal);
    $('.form_loop[data-question=' + que37 + '] button').parents('.form_loop').addClass('d-none').removeClass('d-block');
    $('#callback-form').submit();
   }else {
      $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
      setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
      shakeEffect($parent);
   }
})
}
otpAfterClick()
// CallBack Form
var $Form = $('#callback-form');
$Form.submit(function(e) {
    e.preventDefault();
    $('.loading-wrapper').show();
    // ga('send', 'event', { eventCategory: 'premature-ejaculation', eventAction: 'Submit', eventLabel: 'Premature Ejaculation form', eventValue: 1 });

    $Form.find("input[type='hidden']").each(function() {
      var get_data_handle = $(this).attr('data-handle');
  
      if(get_data_handle=='please-enter-your-medicare-card-details'){
          if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'no'){
            if($(this).val() == ""){
              $(this).remove();
            }    
          }
      }else{
        if($(this).val() == ""){
          $(this).remove();
        }
      }
      
    })

    var redirectionMainUrl = '/cart/42055142801581:1';

  
    $.ajax({
        url: $Form.attr('action'),
        cache: false,
        type: 'post',
        data: $Form.serialize(),
        success: function(itemData) {
            var data = JSON.parse(itemData);
            location.href = redirectionMainUrl;
            var cookieToDelete = 'medical-certificate';
            deleteCookie(cookieToDelete);
            deleteCookie("medical-certificate_lastQuestionafter");
        },
        error: function() {
            alert('is-errors');
        }
    });
});

function CalculateP() {
    var Length = $('.form-selected-answer input').length + 1,
        AnswerLength = 0,
        Percentage = 0,
        customLength = 0;
    if ($('.form-selected-answer [data-handle=' + que0 + ']').val() == 'someone-i-care-for-is-unwell-and-i-would-be-unable-to-attend-while-i-care-for-them') {
        if ($('.form-selected-answer [data-handle=' + que5 + ']').val() == 'Stress' || $('.form-selected-answer [data-handle=' + que5 + ']').val() == 'Mental health related') {
            customLength = 38;
        } else {
            customLength = 18;
        }
    } else {
        if ($('.form-selected-answer [data-handle=' + que5 + ']').val() == 'Stress' || $('.form-selected-answer [data-handle=' + que5 + ']').val() == 'Mental health related') {
            customLength = 36;
        } else {
            customLength = 16;
        }
    }
    for (i = 1; i < Length; i++) {
        if ($('.form-selected-answer input:nth-child(' + i + ')').val() != '') {
            AnswerLength = parseInt(AnswerLength) + 1;
        }
    }
    Percentage = parseInt(AnswerLength / customLength * 100);
    console.log(Percentage, Length, AnswerLength)
    $('.progress_content .progress_title span').html(Percentage);
    $('#form_progress_bar').css('width', Percentage + '%');
}

function fillvalue(question) {
    if ($('.form-selected-answer [data-handle=' + question + ']').val() == '') {
        $('.form-selected-answer [data-handle=' + question + ']').val('No response');
    }
}

function pushHistory(number) {
    window.history.pushState("", "", location.pathname + "?question=" + number);
    ga('send', {
        hitType: 'pageview',
        page: location.pathname + location.search
    });
}

function ValidateRemove() {
    $('.form_loop .valid_date_text').remove();
}

function togglePopup() {
    $(".customer_details_time_section").toggle();
}

$('#book_appoinment').change(function() {
    if ($(this).val() == '9:00 to 5:00') {
        $('.customer_details_time_section').toggle();
    }
});

function IsEmail(email) {
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!regex.test(email)) {
        return false;
    } else {
        return true;
    }
}